import React, { useState } from 'react';
import PropTypes from 'prop-types';

import axios from '@utils/axios';
import { Form, TextField, PageActions } from '@shopify/polaris';

const propTypes = {
  tokenPresent: PropTypes.bool,
  submitURL: PropTypes.string.isRequired,
  setLoading: PropTypes.func.isRequired,
}

const defaultProps = {
  tokenPresent: false
}

const UnimartDeliveryLogin = (props) => {
  const [active, setActive] = useState(props.tokenPresent);
  const [formData, setFormData] = useState({ email: "", password: "" });

  const handleChange = (value, id) => {
    setFormData({
      ...formData,
      [id]: value
    })
  };

  const handleSubmit = async () => {
      let { submitURL, setLoading } = props;
      setLoading(true)
  
      try {
        let response = await axios.post(submitURL, {
          login: formData
        });
        if(response.data.success){
          if (response.data.redirectURL){
            // redirect if required.
            alert("Guardado con éxito");
            window.location = response.data.redirectURL;
            return true
          } else {
            alert(response.data.message);
          }
          
        } // End success data
        else{
          alert(response.data.message);
        }
      } catch (error) {
        alert(error);
      } // END try/catch
      setLoading(false)
  }
  

  return(
    <div>
      <div className="mb10">
        <img src={ imagePaths.unimartDeliveryLogo } height="24" />
      </div>
      { active  &&
        <h5>
          Conexión con Unimart Delivery activa.
        </h5>
      }
      
        <div>
          <Form onSubmit={ handleSubmit } >
            <TextField
              id="email"
              name="email"
              label= { I18n.t("activerecord.attributes.general.email") }
              placeholder="Email"
              onChange={ handleChange }
              value={ formData.email } />
            
            <TextField
              id="password"
              type="password"
              name="password"
              label= { I18n.t("activerecord.attributes.general.password") }
              placeholder="****"
              onChange={ handleChange }
              value={ formData.password } />
          </Form>
  
          <PageActions 
            primaryAction={{
              onAction: handleSubmit,
              loading: props.loading,
              content: I18n.t("actions.save")
            }}
          />
        </div>
    </div>
  )
}

UnimartDeliveryLogin.propTypes = propTypes;
UnimartDeliveryLogin.defaultProps = defaultProps;

export default UnimartDeliveryLogin;